export class AdditionalInfoBE {
    UrlLabel: string = '';
    TransactionIdProvider: string;
}